module.exports = __webpack_public_path__ + "static/media/developIcon.b856cf15.svg";